import { Text } from '..'
import CoinImg from '../../../components/common/CoinImg'
import { SOCKET_URL } from '../../../core/constants/urls'

const CreateStakingStage1 = ({ coins, onSubmit }) => {
	const coinFa = {
		usdt: 'دلار',
		paxg: 'طلا',
		btc: 'بیت کوین'
	}
	return (
		<div className={'max-w-[600px] mx-auto'}>
			<div className={'flex justify-center'}>
				<Text tid={'available-staking-coins'} className={'dark:text-gray-100 text-base'} />
			</div>
			<div className={'grid grid-cols-1 lg:grid-cols-3 gap-3 mx-auto w-full lg:w-max m-3'}>
				{coins.map((c) => {
					return (
						<div
							className={
								'cursor-pointer flex flex-row lg:flex-col items-center lg:justify-center gap-2 rounded-md p-4 lg:h-[120px] w-full lg:w-[140px] bg-slate-200 dark:bg-secondaryBg'
							}
							key={c}
							onClick={() => onSubmit({ currency: c })}
						>
							<CoinImg size={36} id={c} />
							<span>{c.toUpperCase()}</span>
							<span className='text-sm'>{coinFa[c] || ''}</span>
						</div>
					)
				})}
			</div>
		</div>
	)
}

export default CreateStakingStage1
